import { render, staticRenderFns } from "./social-club-container.vue?vue&type=template&id=d560c288&scoped=true&lang=pug"
import script from "./social-club-container.js?vue&type=script&lang=js&external"
export * from "./social-club-container.js?vue&type=script&lang=js&external"
import style0 from "./social-club-container.vue?vue&type=style&index=0&id=d560c288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d560c288",
  null
  
)

export default component.exports